import { useState } from "react";
import { FormModal } from "../../components/Forms/FormModal";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Flex } from "@chakra-ui/react";
import { Input } from "../../components/Forms/Input";
import { TextArea } from "../../components/Forms/TextArea";
import { DatePickerInput } from "../../components/Forms/DateInput";
import { CreateInvoiceData } from "../../models/Invoice";
import { useInvoice } from "../../hooks/useInvoice";
import { clearMask, formatCurrencyToApi, showToast } from "../../utils";
import { formatISO } from "date-fns";

interface CreateInvoiceFormProps {
    isOpen: boolean;
    onClose: () => void;
}



const createInvoiceSchema = yup.object().shape({
    sellerDocument: yup.string().required("Preenchimento obrigatório!"),
    email: yup.string().email("Digite um e-mail válido!").required("Preenchimento obrigatório!"),
    amount: yup.string().required("Preenchimento obrigatório!"),
    observation: yup.string().required("Preenchimento obrigatório!"),
    date: yup.date().required("Preenchimento obrigatório!"),
});

export function CreateInvoiceForm({ isOpen, onClose }: CreateInvoiceFormProps) {
    const { postInvoice } = useInvoice();
    const [isLoading, setIsLoading] = useState(false);
    const {
        register,
        handleSubmit,
        control,
      } = useForm({
        resolver: yupResolver(createInvoiceSchema),
    });
    let formattedDate = new Date();

    async function onSubmit(data: CreateInvoiceData) {
        const parsedDate = formatISO(data.date, { representation: "date" });
        try {
            setIsLoading(true);
            const invoiceData = {
                ...data,
                sellerDocument: clearMask(data.sellerDocument),
                amount: formatCurrencyToApi(data.amount),
                date: parsedDate,
            }
            await postInvoice(invoiceData);
            showToast({
                message: "Nota fiscal criada com sucesso",
                type: "success",
            });
        } catch (error) {
            //@ts-ignore
            error?.response?.data?.errors.map((error) => {
                return  showToast({
                            type: "error",
                            message: `${error?.code} - ${error?.description}`
                        })
            });
        } finally {
            setIsLoading(false);
            onClose();
        }
    }
    return(
        <FormModal
            title="Emitir NF individual"
            isOpen={isOpen}
            onClose={onClose}
            isSubmitting={isLoading}
            handleConfirmModal={handleSubmit(onSubmit)}
            confirmationButtonText="Gerar NF"
            width="650px"
            isAllowToSubmit
        >
            <Flex 
                w="100%"
                gap="2"
                alignItems="center"
            >
                <DatePickerInput 
                    name="date"
                    register={{...register("date")}}
                    label="Data de emissão"
                    selectedDate={formattedDate}
                    control={control}
                    rules={{ required: "Preenchimento obrigatório!" }}
                />
                <Input
                    name="sellerDocument"
                    register={{...register("sellerDocument")}}
                    label="CNPJ"
                    mask="cpf/cnpj"
                    placeholder="000.000.0X0/0001-X0"
                />
            </Flex>
            <Flex
                w="100%"
                gap="2"
            >
                <Input 
                    name="amount"
                    register={{...register("amount")}}
                    label="Valor"
                    mask="currency"
                    placeholder="R$ 10,00"
                />
                <Input
                    name="email"
                    register={{...register("email")}}
                    label="Email"
                    placeholder="financeiro@mail.com.br"
                />
            </Flex>
            <TextArea 
                name="observation"
                register={{...register("observation")}}
                label="Descrição"
                placeholder="Inclua aqui a descrição da NF"
            />
        </FormModal>
    )
}